<!-- Patient ID Label -->
<div class="medical-record-label patient-info-container-inline">
  
  <div class="patient-id-content">
    <span *ngIf="!patient?.patientIDs || patient.patientIDs.length === 0"
          class="medical-record-number-text">
      {{patient.caseName}}
    </span>
    <div *ngIf="patient?.patientIDs && patient.patientIDs.length > 0"
         class="patient-ids-container">
      <!-- Current Patient ID (always shown) -->
      <div *ngIf="currentPatientID"
           class="patient-id-item current-patient-id">
        <div class="patient-id-entry">
          <span class="hospital-label">
            Facility:
          </span>
          <span class="hospital-name">
            {{currentPatientID.facility}}
          </span>
          <span class="separator">
            •
          </span>
          <span class="id-label">
            Patient ID:
          </span>
          <span class="patient-id-value">
            {{currentPatientID.value}}
          </span>
          <!-- Icon button for other IDs -->
          <button *ngIf="hasMultipleIds && otherPatientIDs.length > 0"
                  class="more-ids-icon-button"
                  (click)="showOtherPatientIds()"
                  type="button"
                  [matTooltip]="otherPatientIDs.length + ' other ID' + (otherPatientIDs.length > 1 ? 's' : '')">
            <mat-icon>more_horiz</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

